import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    deviceType: null,
};

const responsiveSlice = createSlice({
    name: 'responsive',
    initialState,
    reducers: {
        setWindowSize: (state, action) => {
            state.deviceType = action.payload;
        },
    },
});

export const responsiveAction = responsiveSlice.actions;

export default responsiveSlice;